import { render, staticRenderFns } from "./per-pwd.vue?vue&type=template&id=56a4df34&scoped=true&"
import script from "./per-pwd.vue?vue&type=script&lang=js&"
export * from "./per-pwd.vue?vue&type=script&lang=js&"
import style0 from "./per-pwd.vue?vue&type=style&index=0&id=56a4df34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a4df34",
  null
  
)

export default component.exports